import { useState } from "react";
import { Copy } from "lucide-react";
import { Tooltip } from "@mantine/core";

const CopyToClipboard = ({ text }: { text: string }) => {
	const [copied, setCopied] = useState("Copy");

	const copyToClipboard = () => {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(text).then(
				() => setCopied("Copied"),
				(err) => console.error("Failed to copy text: ", err),
			);
		} else {
			// Fallback for older browsers
			const textArea = document.createElement("textarea");
			textArea.value = text;
			document.body.appendChild(textArea);
			textArea.select();
			document.execCommand("copy");
			document.body.removeChild(textArea);
			setCopied("Copied");
		}
	};

	return (
		<>
			<Tooltip label={copied}>
				<Copy onClick={copyToClipboard} className="h-3 w-3 cursor-pointer" />
			</Tooltip>
		</>
	);
};

export default CopyToClipboard;
